'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _components = require('../../components');
var _containers = require('../../containers');

var _constants = require('../../constants');
var _multiselectsTitles = require('../../utils/multiselectsTitles');
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _formatSearchBoxData = require('../../utils/formatSearchBoxData');
var _sendSearchRequest = require('../../helpers/sendSearchRequest');var _sendSearchRequest2 = _interopRequireDefault(_sendSearchRequest);

var _SearchBoxContainer = require('./SearchBoxContainer.scss');var styles = _interopRequireWildcard(_SearchBoxContainer);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Helpers
// Styles
var getOptionsConfig = function getOptionsConfig(translate) {return [{ value: _constants.optionTypes.buy, label: translate('buy') },
  { value: _constants.optionTypes.rent, label: translate('rent') },
  { value: 'projects', label: translate('projects') },
  { value: _constants.sections.commercial.location, label: translate('commercial') }];};var


SearchBoxContainer = function (_Component) {_inherits(SearchBoxContainer, _Component);
  function SearchBoxContainer(props) {_classCallCheck(this, SearchBoxContainer);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_this.

















    getInputLocation = function (data) {return _this.setState({ selectedLocation: data });};_this.

    handleChange = function (field, value) {var _this$setState;return _this.setState((_this$setState = {}, _this$setState[field] = value, _this$setState));};_this.

    handleOptionChange = function (value) {
      var stateModifier = { selectedOption: value };

      if (!_constants.optionTypes[value]) {
        stateModifier.section = value;
        stateModifier.optionType = _constants.defaultOptionType;
      } else {
        stateModifier.section = _constants.sections.homes.location;
        stateModifier.optionType = value;
      }

      if (value === 'projects') {
        stateModifier.optionType = null;
      }

      _this.setState(Object.assign({}, stateModifier));
    };_this.

    sendRequest = function () {return (0, _sendSearchRequest2.default)(_this.state, _this.state.selectedLocation, { locale: _this.props.locale });};_this.

    openCloseFilters = function () {
      if (!_this.state.isFiltersShown) {
        (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.homePage, _analyticsConstants.eventAction.open, _analyticsConstants.eventLabel.additionalFilters);
      }
      _this.setState({ isFiltersShown: !_this.state.isFiltersShown });
    };_this.

    clearInputLocation = function () {return _this.setState({ selectedLocation: null });};_this.

    formatPriceParameters = function (field) {return {
        value: _this.state[field],
        onChange: function onChange(value) {return _this.handleChange([field], value);} };};_this.


    renderDesktopTitles = function () {var _cx;return !_this.props.isMobile &&
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.filterTitleRow, (_cx = {}, _cx[styles.shown] = _this.state.isFiltersShown, _cx)) },
        _react2.default.createElement('div', { className: styles.multiSelectTitles },
          _react2.default.createElement('p', null, _this.props.translate('searchContainer', 'propertyTypesTitle')),
          _react2.default.createElement('p', null, _this.props.translate('searchContainer', 'numberOfRoomsTitle'))),

        _react2.default.createElement('div', { className: styles.minMaxPriceTitles },
          _react2.default.createElement('p', null, _this.props.translate('searchContainer', 'minPriceTitle')),
          _react2.default.createElement('p', null, _this.props.translate('searchContainer', 'maxPriceTitle'))));};_this.




    renderDesktopFilters = function () {var _cx2;var _this$props =
      _this.props,translate = _this$props.translate,rootTranslate = _this$props.rootTranslate,propertyTypes = _this$props.propertyTypes,isMobile = _this$props.isMobile;

      if (isMobile) {return null;}

      var currentSection = _constants.sections[_this.state.section] || _constants.sections.homes;
      var currentOptionType = _this.state.optionType || _constants.defaultOptionType;
      var currentPropertyTypes = (0, _get2.default)(propertyTypes, currentSection.value + '.' + currentOptionType);
      var typesInput = (0, _formatSearchBoxData.formatTypes)(currentPropertyTypes, rootTranslate, false, _this.state.optionType);
      var typesTitle = (0, _multiselectsTitles.propertyTypesTitle)(_this.state.propertyTypes, rootTranslate);
      var roomInput = (0, _formatSearchBoxData.formatRooms)(_constants.roomOptions, translate);
      var roomTitle = (0, _multiselectsTitles.roomsTitle)(_this.state.rooms || [], translate);

      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.secondRow, (_cx2 = {}, _cx2[styles.shown] = _this.state.isFiltersShown, _cx2)) },
          _react2.default.createElement('div', { className: styles.multiSelectsContainer },
            _react2.default.createElement(_containers.MultiselectWrapper, {
              className: styles.multiSelects,
              options: typesInput,
              title: typesTitle,
              value: _this.state.propertyTypes,
              onChange: function onChange(value) {return _this.handleChange('propertyTypes', value);},
              multiSelectClassName: 'inHomePage' }),

            _react2.default.createElement(_containers.MultiselectWrapper, {
              className: styles.multiSelects,
              options: roomInput,
              title: roomTitle,
              value: _this.state.rooms,
              onChange: function onChange(value) {return _this.handleChange('rooms', value);},
              multiSelectClassName: 'inHomePage' })),


          _react2.default.createElement(_components.MinMaxPrices, {
            translate: _this.props.translate('searchContainer'),
            minPrice: _this.formatPriceParameters('minPrice'),
            maxPrice: _this.formatPriceParameters('maxPrice'),
            className: styles.minMaxPrice })));



    };_this.

    renderMobileContent = function () {var _cx3;var _this$props2 =
      _this.props,translate = _this$props2.translate,rootTranslate = _this$props2.rootTranslate,propertyTypes = _this$props2.propertyTypes,isMobile = _this$props2.isMobile;

      if (!isMobile) {return null;}

      var currentSection = _constants.sections[_this.state.section] || _constants.sections.homes;
      var currentOptionType = _this.state.optionType || _constants.defaultOptionType;
      var currentPropertyTypes = (0, _get2.default)(propertyTypes, currentSection.value + '.' + currentOptionType);
      var typesInput = (0, _formatSearchBoxData.formatTypes)(currentPropertyTypes, rootTranslate, false, _this.state.optionType);
      var typesTitle = (0, _multiselectsTitles.propertyTypesTitle)(_this.state.propertyTypes, rootTranslate);
      var roomInput = (0, _formatSearchBoxData.formatRooms)(_constants.roomOptions, translate);
      var roomTitle = (0, _multiselectsTitles.roomsTitle)(_this.state.rooms || [], translate);

      return (
        _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.secondRow, (_cx3 = {}, _cx3[styles.shown] = _this.state.isFiltersShown, _cx3)) },
          _react2.default.createElement('div', null,
            _react2.default.createElement('div', { className: styles.multiSelectTitles },
              _react2.default.createElement('p', null, _this.props.translate('searchContainer', 'propertyTypesTitle')),
              _react2.default.createElement('p', null, _this.props.translate('searchContainer', 'numberOfRoomsTitle'))),


            _react2.default.createElement('div', { className: styles.multiSelectsContainer },
              _react2.default.createElement(_containers.MultiselectWrapper, {
                className: styles.multiSelects,
                options: typesInput,
                title: typesTitle,
                value: _this.state.propertyTypes,
                onChange: function onChange(value) {return _this.handleChange('propertyTypes', value);},
                multiSelectClassName: 'inHomePage' }),

              _react2.default.createElement(_containers.MultiselectWrapper, {
                className: styles.multiSelects,
                options: roomInput,
                title: roomTitle,
                value: _this.state.rooms,
                onChange: function onChange(value) {return _this.handleChange('rooms', value);},
                multiSelectClassName: 'inHomePage' }))),



          _react2.default.createElement('div', null,
            _react2.default.createElement('div', { className: styles.minMaxPriceTitles },
              _react2.default.createElement('p', null, _this.props.translate('searchContainer', 'minPriceTitle')),
              _react2.default.createElement('p', null, _this.props.translate('searchContainer', 'maxPriceTitle'))),


            _react2.default.createElement(_components.MinMaxPrices, {
              translate: _this.props.translate('searchContainer'),
              minPrice: _this.formatPriceParameters('minPrice'),
              maxPrice: _this.formatPriceParameters('maxPrice'),
              className: styles.minMaxPrice }))));




    };_this.state = { selectedLocation: null, isFiltersShown: false, rooms: ['all'], propertyTypes: ['all'], optionType: _constants.defaultOptionType, section: _constants.sections.homes.location, minPrice: '', maxPrice: '', selectedOption: _constants.defaultOptionType };return _this;}SearchBoxContainer.prototype.componentDidMount = function componentDidMount() {this.searchButton = document.querySelector('.btn-search');};SearchBoxContainer.prototype.

  render = function render() {var _props =
    this.props,locale = _props.locale,translate = _props.translate,isMobile = _props.isMobile;
    var filterTitle = this.state.isFiltersShown ? translate('less_options') : translate('additional_options');
    var TabsComponent = isMobile ? _components.OMRadioButtonsShortRow : _components.OMRadioButtonsRow;

    var locusSearchConfig = {
      locale: locale };


    return (
      _react2.default.createElement('div', { className: styles.searchBoxContainer },
        _react2.default.createElement(TabsComponent, {
          onChange: this.handleOptionChange,
          selectedValue: this.state.selectedOption,
          name: 'search-box-options',
          values: getOptionsConfig(translate) }),

        _react2.default.createElement('div', { className: styles.formWrapper },
          _react2.default.createElement('div', { className: styles.locationWrapper },
            _react2.default.createElement(_components.HomePageLocationInput, {
              placeholder: '' + this.props.translate('searchContainer', 'search_address'),
              locale: locale,
              locusSearchConfig: locusSearchConfig,
              getInputData: this.getInputLocation,
              focusSearchNode: this.searchButton,
              clearInput: this.clearInputLocation,
              className: styles.locationInput }),

            _react2.default.createElement('button', { className: 'btn-search', onClick: this.sendRequest },
              _react2.default.createElement('span', { className: 'icon icon-search' }))),



          this.renderDesktopTitles(),

          this.renderDesktopFilters(),

          this.renderMobileContent(),

          _react2.default.createElement('span', { className: styles.btnLink, onClick: this.openCloseFilters },
            filterTitle, '\xA0',

            _react2.default.createElement('span', { className: 'icon icon-caret-down' })))));




  };return SearchBoxContainer;}(_react.Component);


SearchBoxContainer.propTypes = {
  isMobile: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  propertyTypes: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func };exports.default =


SearchBoxContainer;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/SearchBoxContainer/SearchBoxContainer.js
// module id = 1250
// module chunks = 0